export default "__VITE_ASSET__B37r9PFV__"